import React, { useContext, useState, useEffect, useRef } from "react"
import Context from "../utils/Context"
import { sendTaskToRobot, cancelActions } from "../utils/ROS/ROSFunctions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faStopCircle, faCompass, faDolly, faChargingStation, faMinusCircle, faBoxOpen, faBan } from '@fortawesome/free-solid-svg-icons'
import ShowMessage from "../components/ShowMessage"
import api from "../api/api"
import ListOrders from "./ListOrders"
import ROSLIB from "roslib"

export default function Missions() {
  const context = useContext(Context)
  const [orders, setOrders] = useState()

  const defaultOrder = { createdBy: context.user && context.user._id, owner: context.user && context.user.owner }
  const [selectedOrder, setSelectedOrder] = useState(defaultOrder)
  const [filters, setFilters] = useState({ dtCompleted: { $exists: false }, cancelled: false })
  const isMounted = useRef(true)
  const listHeaders = ["missão", "robô", "início", "estado", "ação"]
  const [cancelled, setCancelled] = useState(null)
  const [lastPick, setLastPick] = useState({ point: '', height: '' })
  const [updater, setUpdater] = useState(true)
  const [lastDrop, setLastDrop] = useState(localStorage.getItem("lastDrop") ? JSON.parse(localStorage.getItem("lastDrop")) : { point: '', height: '' })
  const refreshRate = 5000

  const [usedItems, setUsedItems] = useState([]);
  const [racks, setRacks] = useState([])
  const [rows, setRows] = useState([])
  const [positions, setPositions] = useState([])

  //const [showCountdown, setShowCountdown] = useState(false)
  const [countdown, setCountdown] = useState(10)
  //const [timer, setTimer] = useState(null)

  // start task
  const startTask = (mission) => {
    if (mission) {
      sendTaskToRobot({ actions: mission.actions, id: mission.name, name: mission.name })
      context.actions.setMessage({ message: "Missão iniciada!", type: "success" })
      console.log('publicando missão: ', { actions: mission.actions, id: mission.name, name: mission.name })
    }
  }

  useEffect(() => {
    if (isMounted.current)
      api
        .fetchOrders(filters)
        .then((res) => {
          res && isMounted.current && setOrders(res.data)
        })
        .catch((e) => console.log(e))
  }, [cancelled])

  useEffect(() => {
    if (context.palletHeight !== 0) {
      const index = racks?.find(r => r.pointName === lastDrop.point)?.levels.findIndex(l => l === lastDrop.height)

      if (index !== -1) {
        if (parseFloat(racks?.find(r => r.pointName === lastDrop.point)?.maxHeights[index]) - 0.2 < context.palletHeight && racks?.find(r => r.pointName === lastDrop.point)?.maxHeights[index] !== '0.0') {
          context.actions.setModalState({ ...context.modalState, verification: true })
          stopMission()
        } else verifyHeight()
      }
    }
  }, [context.palletHeight])

  useEffect(() => {
    console.log('PALLET WEIGHT: ', context.palletWeight)
    if (context.palletWeight !== 0) {
      if (racks?.find(r => r.pointName === lastDrop.point)?.maxWeight < context.palletWeight) {
        context.actions.setModalState({ ...context.modalState, verification: true })
        stopMission()
      } else verifyWeight()
    }
  }, [context.palletWeight])

  useEffect(() => {
    const refresher = setInterval(() => {

      if (isMounted.current)
        api
          .fetchOrders(filters)
          .then((res) => {
            res && isMounted.current && setOrders(res.data)
          })
          .catch((e) => console.log(e))
    }, refreshRate)

    return () => {
      if (refresher) clearInterval(refresher)
    }
  }, [])

  useEffect(() => {
    if (updater) {
      api.fetchRacks()
        .then((res) => {
          res && setRacks(res.data)
          setPositions(Array.from({ length: Math.ceil(parseInt(res.data.findLast(r => r.position.slice(2)).position.slice(2)) / 9) }, (_, i) => i))

          let rowCount
          res.data.forEach((r, i) => {
            if (i === 0) {
              rowCount = [r.position.slice(0, 1)]
            } else if (!rowCount.some(row => row === r.position.slice(0, 1))) {
              rowCount.push(r.position.slice(0, 1))
            }
          })

          setRows(rowCount)
          setUpdater(false)
        })
    }
  }, [updater])

  const changeOccupation = (positionCode, value) => {
    const posArray = positionCode.split(".")

    const position = posArray[0].concat("." + posArray[1])
    const level = posArray[2]

    api.updateOccupation(position, level, value)
      .then((res) => {
        res && console.log(res)
        setUpdater(true)
      })
      .catch((e) => console.log(e))
  }

  const verifyHeight = () => {
    let info

    if (context.selectedRobot.ROS === 'ROS2') {
      info = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/verify_height_machine/success",
        messageType: "std_msgs/msg/Bool",
      })
    } else {
      info = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/verify_height_machine/success",
        messageType: "std_msgs/Bool",
      })
    }

    console.log("sending verification to robot", true)
    var comm = new ROSLIB.Message({ data: true })
    info.publish(comm)

    context.actions.setPalletHeight(0)
  }

  const verifyWeight = () => {
    let info

    if (context.selectedRobot.ROS === 'ROS2') {
      info = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/weigh_machine/success",
        messageType: "std_msgs/msg/Bool",
      })
    } else {
      info = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/weigh_machine/success",
        messageType: "std_msgs/Bool",
      })
    }

    console.log("sending verification to robot", true)
    var comm = new ROSLIB.Message({ data: true })
    info.publish(comm)

    context.actions.setPalletWeight(0)
  }

  const cancelledSet = cancel => setCancelled(cancel)

  const selectOrder = (orderId) => {
    if (!orderId) {
      setSelectedOrder(defaultOrder)
      return false
    }
    setSelectedOrder(orders.find((order) => order._id === orderId))
  }


  const startDistribution = async () => {
    try {

      await api.startDistributions({
        robotId: context.robotInfo?._id ? context.robotInfo._id : "61c0a9c3b24bdab600ad244c",
        robotName: context.robotInfo?.name ? context.robotInfo.name : "1500PT",
        owner: context.robotInfo?.owner ? context.robotInfo.owner : "Generic",
        createdBy: context.user ? context.user._id : '',
        operationId: context.operation ? context.operation._id : '66857bb15067644208b3827c'
      })

      context.actions.setMessage({ message: "Começar distribuição", type: "success" })

    } catch (error) {
      context.actions.setMessage({ message: "Erro a começar", type: "error" })
    }

  }



  // execute a mission
  const execMission = (missionName) => {
    const mission = context.availableMissions.find(m => m.name === missionName)
    const hasUV = mission?.actions?.find(action => action.name === "desinfect-uv" || action.name === "desinfect-all")

    if (mission) {

      context.actions.setCurrentMission({ ...mission, hasUV: hasUV ? true : false })
    }

    startTask(mission)

  }

  const startCharger = () => {

    var string = {
      "robot": "1500PT",
      "mapIndex": 0,
      "name": "Charger",
      "actions": [
        {
          "id": "go-to",
          "name": "go-to",
          "needsValue": true,
          "value": "Charger"
        },
        {
          "id": "dock",
          "name": "dock",
          "needsValue": true,
          "value": "charger"

        },
        {
          "id": "orientate-to",
          "name": "orientate-to",
          "needsValue": true,
          "value": "A_Charger"
        }
      ]
    }

    startTask(string)

  }

  const releaseCharge = () => {

    var string = {
      "robot": "1500PT",
      "mapIndex": 0,
      "name": "ReleaseCharger",
      "actions": [
        {
          "id": "orientate-to-fork",
          "name": "orientate-to-fork",
          "needsValue": true,
          "value": "A_Portao_Armazem"
        },
        {
          "id": "release-charger",
          "name": "release-charger",
          "needsValue": true,
          "value": ""

        },
        {
          "id": "go-to",
          "name": "go-to",
          "needsValue": true,
          "value": "A_Portao_Armazem"
        },
        {
          "id": "fork",
          "name": "fork",
          "needsValue": true,
          "value": "0.1"
        }
      ]
    }

    startTask(string)
  }

  const frente = async () => {

    var string = {
      "robot": "1500ST3M",
      "mapIndex": 0,
      "name": "fork",
      "actions": [
        {
          "id": "fork",
          "name": "fork",
          "needsValue": true,
          "value": "0.0"
        }
      ]
    }

    startTask(string)

  }

  const stopMission = async () => {
    cancelActions({ stopAll: true }, context.selectedRobot.ROS)
    context.actions.setCurrentMission(null)

    if (context.lastMission.slice(0, 7) === 'Retreat' || context.lastMission.slice(0, 13) === 'EmergencyDrop') {
      context.actions.setLastDrop({ point: '', height: '' })
      localStorage.setItem("lastDrop", JSON.stringify({ point: '', height: '' }))
      context.actions.setMessage({ message: "Missão parada!", type: "success" })
      return
    }

    if (context.forkHeight.toFixed(2) > 0.15) {
      if (context.load) {
        var cancelDrop = {
          "robot": "1500ST3M",
          "name": "EmergencyDrop-" + lastPick.point,
          "actions": [
            {
              "id": "go-to",
              "name": "go-to",
              "needsValue": true,
              "value": "A" + lastDrop.point
            },
            {
              "id": "fork",
              "name": "fork",
              "needsValue": true,
              "value": "0.15"
            },
            {
              "id": "go-to",
              "name": "go-to",
              "needsValue": true,
              "value": "A" + lastPick.point
            },
            {
              "id": "orientate-to-fork",
              "name": "orientate-to-fork",
              "needsValue": true,
              "value": lastPick.point
            },
            {
              "id": "fork",
              "name": "fork",
              "needsValue": true,
              "value": (parseFloat(lastPick.height) + parseFloat(context.forkDiff)).toString()
            },
            {
              "id": "orientate-to-fork",
              "name": "orientate-to-fork",
              "needsValue": true,
              "value": lastPick.point
            },
            {
              "id": "move",
              "name": "move",
              "needsValue": true,
              "value": "-1.4"
            },
            {
              "id": "fork",
              "name": "fork",
              "needsValue": true,
              "value": lastPick.height
            },
            {
              "id": "undock-pallet",
              "name": "undock-pallet",
              "needsValue": false
            },
            {
              "id": "fork",
              "name": "fork",
              "needsValue": true,
              "value": "0.0"
            },
          ]
        }

        if (lastPick.point.slice(2, 6) === 'Rack' && (lastDrop.point.slice(2, 6) !== 'Rack' || lastPick.point.slice(2, 7) !== lastDrop.point.slice(2, 7))) {
          var prePoint = [
            {
              "id": "go-to",
              "name": "go-to",
              "needsValue": true,
              "value": "A_" + lastPick.point.slice(2, 7)
            },
            {
              "id": "orientate-to",
              "name": "orientate-to",
              "needsValue": true,
              "value": "A" + lastPick.point
            }
          ]

          cancelDrop.actions = prePoint.concat(cancelDrop.actions)
        }

        setLastDrop({ ...lastPick })
        context.actions.setLastDrop({ ...lastPick })
        localStorage.setItem("lastDrop", JSON.stringify({ ...lastPick }))
        console.log(cancelDrop)
        context.actions.setMessage({ message: "A devolver palete!", type: "success" })
        startTask(cancelDrop)
      } else {
        var retreat = {
          "robot": "1500ST3M",
          "name": "Retreat-" + lastPick.point,
          "actions": [
            {
              "id": "go-to",
              "name": "go-to",
              "needsValue": true,
              "value": "A" + lastPick.point
            },
            {
              "id": "fork",
              "name": "fork",
              "needsValue": true,
              "value": "0.0"
            }
          ]
        }

        setLastDrop({ ...lastPick })
        context.actions.setLastDrop({ ...lastPick })
        localStorage.setItem("lastDrop", JSON.stringify({ ...lastPick }))
        console.log(retreat)
        context.actions.setMessage({ message: "A recuar!", type: "success" })
        startTask(retreat)
      }
    } else {
      if (context.load) {
        var cancelDrop = {
          "robot": "1500ST3M",
          "name": "EmergencyDrop-" + lastPick.point,
          "actions": [
            {
              "id": "go-to",
              "name": "go-to",
              "needsValue": true,
              "value": "A" + lastPick.point
            },
            {
              "id": "orientate-to-fork",
              "name": "orientate-to-fork",
              "needsValue": true,
              "value": lastPick.point
            },
            {
              "id": "fork",
              "name": "fork",
              "needsValue": true,
              "value": (parseFloat(lastPick.height) + parseFloat(context.forkDiff)).toString()
            },
            {
              "id": "orientate-to-fork",
              "name": "orientate-to-fork",
              "needsValue": true,
              "value": lastPick.point
            },
            {
              "id": "move",
              "name": "move",
              "needsValue": true,
              "value": "-1.4"
            },
            {
              "id": "fork",
              "name": "fork",
              "needsValue": true,
              "value": lastPick.height
            },
            {
              "id": "undock-pallet",
              "name": "undock-pallet",
              "needsValue": false
            },
            {
              "id": "fork",
              "name": "fork",
              "needsValue": true,
              "value": "0.0"
            },
          ]
        }

        if (lastPick.point.slice(2, 6) === 'Rack' && (lastDrop.point.slice(2, 6) !== 'Rack' || lastPick.point.slice(2, 7) !== lastDrop.point.slice(2, 7))) {
          var prePoint = [
            {
              "id": "go-to",
              "name": "go-to",
              "needsValue": true,
              "value": "A_" + lastPick.point.slice(2, 7)
            },
            {
              "id": "orientate-to",
              "name": "orientate-to",
              "needsValue": true,
              "value": "A" + lastPick.point
            }
          ]

          cancelDrop.actions = prePoint.concat(cancelDrop.actions)
        }

        setLastDrop({ ...lastPick })
        context.actions.setLastDrop({ ...lastPick })
        localStorage.setItem("lastDrop", JSON.stringify({ ...lastPick }))
        console.log('DROP CANCELLED!', cancelDrop)
        context.actions.setMessage({ message: "A devolver palete!", type: "success" })
        startTask(cancelDrop)
      } else {
        setLastDrop({ point: '', height: '' })
        context.actions.setMessage({ message: "Missão parada!", type: "success" })
      }
    }
  }

  const execLocation = () => {

    sendTaskToRobot({ actions: [{ value: "Base", name: "publish-pose" }], id: "Base", name: "PRIORITY" })
    context.actions.setMessage({ message: "Ok!", type: "success" })

  }


  const unoccupyEvent = async () => {
    try {
      await api.updateUsed({ positions: document.getElementById('unoccupy-select').value }, 1)

    } catch (error) {
      context.actions.setMessage({ message: "Erro a desocupar", type: "error" })
    }
    context.actions.setMessage({ message: "Posição desocupada: " + document.getElementById('unoccupy-select').value, type: "success" })
  }

  const unoccupyAll = async () => {
    try {
      await api.deleteUsed(1)
    } catch (error) {
      context.actions.setMessage({ message: "Erro a desocupar", type: "error" })
    }
    context.actions.setMessage({ message: "Tudo desocupado", type: "success" })
  }


  // end of countdown
  /*useEffect(() => {
    if (countdown === 0) {
      clearInterval(timer)
      setTimer(null)
      setShowCountdown(false)
      setCountdown(10)
      startTask(context.currentMission)
    }
  }, [countdown, context.currentMission, timer])*/


  const transportRequest = () => {
    let pickPoint = document.getElementById('pick-select').value
    let pickHeight = document.getElementById('pick-height') ? document.getElementById('pick-height').value : null
    let dropPoint = document.getElementById('drop-select').value
    let dropHeight = document.getElementById('drop-height') ? document.getElementById('drop-height').value : null

    if (pickPoint === '' || pickHeight === '' || dropPoint === '' || dropHeight === '') {
      context.actions.setMessage({ message: "Por favor preencha todos os campos.", type: "error" })
      return false
    }

    if (!pickHeight) pickHeight = '0.0'
    if (!dropHeight) dropHeight = '0.0'


    setLastPick({ point: pickPoint, height: pickHeight })

    var string = {
      "robot": "1500ST3M",
      "name": "P-" + pickPoint + (pickHeight !== '0.0' ? "-" + pickHeight : '') + " & D-" + dropPoint + "-" + dropHeight,
      "actions": [
        //PICK
        {
          "id": "go-to",
          "name": "go-to",
          "needsValue": true,
          "value": "A" + pickPoint
        },
        {
          "id": "orientate-to-fork",
          "name": "orientate-to-fork",
          "needsValue": true,
          "value": pickPoint
        },
        {
          "id": "fork",
          "name": "fork",
          "needsValue": true,
          "value": pickHeight
        },
        {
          "id": "orientate-to-fork",
          "name": "orientate-to-fork",
          "needsValue": true,
          "value": pickPoint
        },
        {
          "id": "verify-height",
          "name": "verify-height",
          "needsValue": false
        },
        {
          "id": "move",
          "name": "move",
          "needsValue": true,
          "value": "-1.4"
        },
        {
          "id": "weigh",
          "name": "weigh",
          "needsValue": true,
          "value": (parseFloat(pickHeight) + parseFloat(context.forkDiff)).toString()
        },
        {
          "id": "undock-pallet",
          "name": "undock-pallet",
          "needsValue": false
        },
        {
          "id": "fork",
          "name": "fork",
          "needsValue": true,
          "value": "0.15"
        },
        //DROP
        {
          "id": "go-to",
          "name": "go-to",
          "needsValue": true,
          "value": "A" + dropPoint
        },
        {
          "id": "orientate-to-fork",
          "name": "orientate-to-fork",
          "needsValue": true,
          "value": dropPoint
        },
        {
          "id": "fork",
          "name": "fork",
          "needsValue": true,
          "value": (parseFloat(dropHeight) + parseFloat(context.forkDiff)).toString()
        },
        {
          "id": "orientate-to-fork",
          "name": "orientate-to-fork",
          "needsValue": true,
          "value": dropPoint
        },
        {
          "id": "move",
          "name": "move",
          "needsValue": true,
          "value": "-1.4"
        },
        {
          "id": "fork",
          "name": "fork",
          "needsValue": true,
          "value": dropHeight
        },
        {
          "id": "undock-pallet",
          "name": "undock-pallet",
          "needsValue": false
        },
        {
          "id": "fork",
          "name": "fork",
          "needsValue": true,
          "value": "0.0"
        }
      ]
    }

    let prePoint

    if (pickPoint.slice(2, 6) === 'Rack' && (lastDrop?.point.slice(2, 6) !== 'Rack' || pickPoint.slice(2, 7) !== lastDrop?.point.slice(2, 7))) {
      prePoint = [
        {
          "id": "go-to",
          "name": "go-to",
          "needsValue": true,
          "value": "A_" + pickPoint.slice(2, 7)
        },
        {
          "id": "orientate-to",
          "name": "orientate-to",
          "needsValue": true,
          "value": "A" + pickPoint
        }
      ]

      string.actions = prePoint.concat(string.actions)

      if (dropPoint.slice(2, 6) === 'Rack' && pickPoint.slice(2, 7) !== dropPoint.slice(2, 7)) {
        prePoint = [
          {
            "id": "go-to",
            "name": "go-to",
            "needsValue": true,
            "value": "A_" + dropPoint.slice(2, 7)
          },
          {
            "id": "orientate-to",
            "name": "orientate-to",
            "needsValue": true,
            "value": "A" + dropPoint
          }
        ]

        string.actions.splice(10, 0, ...prePoint)
      }
    } else if (dropPoint.slice(2, 6) === 'Rack' && pickPoint.slice(2, 7) !== dropPoint.slice(2, 7)) {
      prePoint = [
        {
          "id": "go-to",
          "name": "go-to",
          "needsValue": true,
          "value": "A_" + dropPoint.slice(2, 7)
        },
        {
          "id": "orientate-to",
          "name": "orientate-to",
          "needsValue": true,
          "value": "A" + dropPoint
        }
      ]

      string.actions.splice(8, 0, ...prePoint)
    }

    setLastDrop({ point: dropPoint, height: dropHeight })
    context.actions.setLastDrop({ point: dropPoint, height: dropHeight })
    localStorage.setItem("lastDrop", JSON.stringify({ point: dropPoint, height: dropHeight }))
    console.log(string)
    startTask(string)
  }

  return (
    <div>
      <button
        onClick={() => context.actions.setModalState({ ...context.modalState, missions: true })}
        className="button is-success mb-5 mr-3"
        styles={{ marginRight: "1rem" }}
      >
        <FontAwesomeIcon icon={faPlus} className="is-small mr-7" />
        Manage Missions
      </button>

      <button className="button is-warning mr-2 mb-2" onClick={() => startCharger()}>
        <FontAwesomeIcon icon={faChargingStation} className="is-small mr-1" />
        Charge
      </button>

      <button className="button is-outlined is-link mr-2 mb-2" onClick={() => releaseCharge()}>
        <FontAwesomeIcon icon={faMinusCircle} className="is-small mr-1" />
        Release Charger
      </button>

      <button className="button is-info mr-2 mb-2" onClick={() => execLocation()}>
        <FontAwesomeIcon icon={faCompass} className="is-small mr-1" />
        Locate
      </button>

      <button className="button is-outlined is-link mr-2 mb-2" onClick={() => frente()}>
        <FontAwesomeIcon icon={faDolly} className="is-small mr-1" />
        Lower Fork
      </button>

      <button
        onClick={stopMission}
        className="button is-danger mb-5 mr-3"
      >
        <FontAwesomeIcon icon={faStopCircle} className="is-small mr-1" />
        Cancel All
      </button>

      <div className="panel">
        <div style={{ textAlign: 'center', fontSize: 28, marginBottom: '20px', color: '#052318' }}>
          <p style={{ marginBottom: '10px' }}>
            Pick from: <div class='control' style={{ display: 'inline' }}>
              <select id='pick-select' style={{ fontSize: 24, textAlign: 'center', minWidth: '200px' }}>
                <option value='' selected disabled style={{ textAlign: 'left' }}>Ponto de pick...</option>
                {racks &&
                  racks.map((r) => {
                    if (r.occupation.some(o => o === true)) return <option value={r.pointName} style={{ textAlign: 'left' }}>{r.pointName}</option>
                  })
                }
              </select>

              {document.getElementById('pick-select')?.value.slice(2, 6) === 'Rack' &&
                <select id='pick-height' style={{ fontSize: 24, textAlign: 'center', minWidth: '200px' }}>
                  <option value='' selected disabled style={{ textAlign: 'left' }}>Altura de pick...</option>
                  {racks.find(r => r.pointName === document.getElementById('pick-select')?.value)?.levels?.map((l, i) => {
                    if (racks.find(r => r.pointName === document.getElementById('pick-select')?.value).occupation[i] === true) return <option value={l} style={{ textAlign: 'left' }}>{i} - {l}m</option>
                  })}
                </select>
              }
            </div>

          </p>

          <p style={{ marginBottom: '10px' }}>
            Drop to: <div class='control' style={{ display: 'inline' }}>
              <select id='drop-select' style={{ fontSize: 24, textAlign: 'center', minWidth: '200px' }}>
                <option value='' selected disabled style={{ textAlign: 'left' }}>Ponto de drop...</option>
                {racks &&
                  racks.map((r) => {
                    if (r.occupation.some(o => o === false)) return <option value={r.pointName} style={{ textAlign: 'left' }}>{r.pointName}</option>
                  })
                }
              </select>

              {document.getElementById('drop-select')?.value.slice(2, 6) === 'Rack' &&
                <select id='drop-height' style={{ fontSize: 24, textAlign: 'center', minWidth: '200px' }}>
                  <option value='' selected disabled style={{ textAlign: 'left' }}>Altura de drop...</option>
                  {racks.find(r => r.pointName === document.getElementById('drop-select')?.value)?.levels?.map((l, i) => {
                    if (racks.find(r => r.pointName === document.getElementById('drop-select')?.value).occupation[i] === false) return <option value={l} style={{ textAlign: 'left' }}>{i} - {l}m</option>
                  })}
                </select>
              }
            </div>
          </p>

          <p>
            <button className='button is-medium is-outlined is-link mr-2 mb-2' onClick={transportRequest}>
              Send Request
            </button>
          </p>
        </div>

        <ShowMessage />
      </div>


      {/*orders &&
        <div className="box" style={{ "borderRadius": "15px", "textAlign": "center" }}>
          <div className="column is-12">
            <ListOrders data={orders} handler={selectOrder} headers={listHeaders} cancelled={cancelledSet} cancelledValue={cancelled} />
          </div>
        </div>
      */}

      {context.availableMissions.length > 0 && context?.ownerUser === 'FI' &&
        context.availableMissions.map((mission, i) => (
          mission.robot === context.selectedRobot.name && mission.mapIndex === context.mapIndex &&
          <button key={i} className="button is-outlined is-link mr-2 mb-2" onClick={() => execMission(mission.name)}>
            {mission.name + " "}
          </button>
        ))}

      <div className="title">
        OCUPAÇÃO
      </div>
      {racks && rows &&
        rows.map(row =>
          <div className='panel'>
            <div>
              {row === '0' ? 'CHÃO' : 'CORREDOR ' + row}
            </div>

            {row === '0' ?
              <div className='fixed-grid has-9-cols'>
                <div className='grid'>
                  {racks.filter(r => r.position.slice(0, 2) === '00').map(r => {
                    if (r.occupation[0]) return <div className='cell' onClick={() => changeOccupation(r.position + '.' + 0, false)} style={{ backgroundColor: 'red' }}></div>
                    else return <div className='cell' onClick={() => changeOccupation(r.position + '.' + 0, true)}></div>
                  })}
                </div>
              </div>
              :
              <div className='fixed-grid has-9-cols'>
                {positions.map((p, divider) => {
                  return <div style={{ marginBottom: divider !== positions.length - 1 ? '50px' : '' }}>
                    {racks.find(r => r.position.slice(0, 1) === row).levels.map((l, i) => {
                      const level = (racks.find(r => r.position.slice(0, 2) !== '00').levels.length - 1) - i

                      return <div className='grid'>
                        {racks.filter(r => r.position.slice(0, 1) === row && parseInt(r.position.slice(2)) <= 9 * (divider + 1) && parseInt(r.position.slice(2)) > 9 * divider).map((r, j) => {
                          if (r.occupation[level]) return <div className='cell' onClick={() => changeOccupation(r.position + '.' + level, false)} style={{ backgroundColor: 'red' }}>{r.position + '.' + level}</div>
                          else return <div className='cell' onClick={() => changeOccupation(r.position + '.' + level, true)}>{r.position + '.' + level}</div>
                        })}
                      </div>
                    })}
                  </div>
                })}
              </div>
            }
          </div>
        )
      }
    </div>
  )
}